<script lang="ts">
  let userInput;
  let result;
  let emoji;

  const virginEmojis = ["🐼", "💩", "🤓", "🥸", "😵‍💫", "🤌", "😁", "😊", "🐸", "🤐", "🤫", "👋"];
  const noVirginEmojis = ["🍺", "🥒", "🥳", "🥸", "😎", "🤡", "👻", "💋"];

  function calculatePanda() {
    if (!userInput) {
      return;
    }

    const startOfVirgin = new Date(userInput);
    startOfVirgin.setMonth(+startOfVirgin.getMonth() + 3);

    const now = new Date();
    const daysLeft = datediff(now, startOfVirgin);

    result =
      daysLeft < 0
        ? `Congrats, you're a virgin since ${-daysLeft} days.`
        : `Puhh, you have ${daysLeft} days left until you're a virgin.`;

    if (daysLeft < 0) {
      emoji = virginEmojis[Math.floor(Math.random() * virginEmojis.length)];
    } else {
      emoji = noVirginEmojis[Math.floor(Math.random() * noVirginEmojis.length)];
    }
  }

  function datediff(first, second) {
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
  }

  function reloadPage() {
    location.reload();
  }
</script>

<main>
  <div class="spacing-top">
    <div />
  </div>
  <div class="">
    <div class="container">
      <div class="row">
        <div class="col-3 d-xl-none" />
        <div class="col-12 col-lg-6 col-xl-6">
          <div class="input-zone">
            {#if result}
              <h1 style="line-height: 0px; padding-top: 2.5rem !important;">
                {emoji}
              </h1>
              <h2>{result}</h2>
              <button on:click={reloadPage}>Recalculate</button>
            {:else}
              <h1>🐼-Point Calculator</h1>
              <p>The last time you had sex:</p>
              <input type="date" bind:value={userInput} />
              <br />
              <button on:click={calculatePanda}>Calculate</button>
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<style>
  :global(body) {
    background: rgb(34, 193, 195);
    background: linear-gradient(
      0deg,
      rgba(34, 193, 195, 1) 0%,
      rgba(253, 187, 45, 1) 100%
    );
    height: 100vh;
    padding: 0;
    margin: 0;
  }

  :global(input) {
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 0.5rem;
    border: 0 solid #e5e7eb;
    box-shadow: drop-shadow(0 4px 3px rgb(0 0 0/0.07))
      drop-shadow(0 2px 2px rgb(0 0 0/0.06));
    width: 100%;
    font-size: 16px;
    padding: 1rem !important;
    text-align: center;
  }

  :global(button) {
    background-color: #faba30bd;
    border-radius: 0.5rem !important;
    border: 0 solid #e5e7eb;
    width: 100%;
    font-size: 16px;
    padding: 1rem;
    transition: 0.2s;
    color: rgb(226, 226, 226);
    font-weight: bold;
    text-transform: uppercase !important;
    margin-top: 1rem !important;
  }

  .spacing-top {
    height: 23vh;
  }

  .input-zone {
    background-color: rgba(255, 255, 255, 0.3);
    padding: 1rem 2rem;
    border-radius: 0.5rem;
    border: 0 solid #e5e7eb;
    box-shadow: drop-shadow(0 4px 3px rgb(0 0 0/0.07))
      drop-shadow(0 2px 2px rgb(0 0 0/0.06));
    margin: 0 auto;
    width: 100%;
    text-align: center;
  }

  h1 {
    font-weight: bold;
    padding: 1rem 0;
    font-size: 80px;
    margin-top: 2rem;
    line-height: 60px;
    font-family: "Dongle", sans-serif;
  }

  h2 {
    font-weight: bold;
    padding: 1rem 0;
    font-size: 60px;
    margin-top: 1rem;
    line-height: 40px;
    font-family: "Dongle", sans-serif;
  }
</style>
